
import { Vue, Component, Prop } from 'vue-property-decorator'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'
interface Goal {
  description: string;
  title: string;
}

@Component({
  name: 'GoalPreview',
  components: { ChoiceIcon }
})
export default class GoalPreview extends Vue {
  @Prop() title!: string
  @Prop() goal!: Goal
}
